import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <LandingPage data-id="element-0" />;
}
export { App };